// extracted by mini-css-extract-plugin
export default {"headerWrapper":"OrderHeader_headerWrapper__sdeK4","header":"OrderHeader_header__4X9v6","title":"OrderHeader_title__nr587"};